import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import PageLayout, { PageLayoutProps } from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import { ContainerWidthProvider } from '@ms/yammer-web-core-ui/dist/util/responsiveness';
import React, { FC } from 'react';

import LoadableAppLayout from './LoadableAppLayout';

const PageLayoutSwitcher: FC<PageLayoutProps> = (props) => {
  const isNewPageLayoutEnabled = useExperimentTreatmentWithoutReporting(Experiment.PageLayoutVNextWebApp) === 'enabled';

  return isNewPageLayoutEnabled ? (
    <ContainerWidthProvider>
      <LoadableAppLayout {...props} />
    </ContainerWidthProvider>
  ) : (
    <PageLayout {...props} />
  );
};

export default PageLayoutSwitcher;
